import { Link } from 'react-router-dom';
import styled from 'styled-components';

import type { ThemeSpaceType } from 'src/styles/theme';

export const Container = styled.div<{ marginBottom?: ThemeSpaceType; marginTop?: ThemeSpaceType }>`
  margin: 0;
  margin-top: ${props => (props.marginTop ? props.theme.space[props.marginTop] : props.theme.space.s5)};
  margin-bottom: ${props => (props.marginBottom ? props.theme.space[props.marginBottom] : props.theme.space.s7)};
`;

export const StyledLink = styled(Link)`
  color: ${props => props.theme.colors.capsuleGreen50} !important;
`;
